import { broadcastEvent } from './event-emitter';

export const ANNOUNCE_EVENT = 'live-announce';

export type AnnouncePoliteness = 'polite' | 'assertive';

export const announce = (message: string, politeness: AnnouncePoliteness = 'polite') => {
	broadcastEvent(ANNOUNCE_EVENT, message, politeness);
};
